// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  height: 9%;
}

.content {
  padding-left: 5px;
  padding-right: 5px;
}

.sidebar {
  mix-blend-mode: normal;
  background-color: #EAEAEA;
  width: 200px;
  flex-basis: 200px;
  min-width: 200px;
}

.menu-item-text {
  color: #B2B2B2;
  font-weight: 600;
  text-align: left;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.083333px;
  min-height: 25px;
  padding-left: 10px;
}

.menu {
  margin-top: 5px;
  overflow-y: auto;
  height: calc(100% - 50px);
}

.active-heading {
  color: var(--theme-main-color, #055C8D);
}

.terminate-button {
  height: 50px;
  text-align: center;
  align-content: center;
  align-self: center;
}

.content-area {
  min-height: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
